import { jsx } from '@emotion/core';
import React from 'react';
import { useFocusVisible } from '@zendeskgarden/container-focusvisible';
import { labelStyles, nativeRadioStyles, FocusHighlight } from './styles';
import { Context } from './context';
var FOCUS_VISIBLE_CLASSNAME = 'focus-visible';
var FOCUS_VISIBLE_DATA_ATTR = 'data-focus-visible';
export var Item = function Item(_a) {
  var children = _a.children,
      value = _a.value;

  var _b = React.useContext(Context),
      selectedValue = _b.selectedValue,
      size = _b.size,
      _onChange = _b.onChange,
      disabled = _b.disabled,
      name = _b.name;

  var checked = selectedValue.length > 0 && value === selectedValue;
  var focusVisibleRef = React.useRef(null);
  useFocusVisible({
    scope: focusVisibleRef,
    className: FOCUS_VISIBLE_CLASSNAME,
    dataAttribute: FOCUS_VISIBLE_DATA_ATTR
  });
  return jsx("label", {
    ref: focusVisibleRef,
    css: labelStyles(size, checked, disabled)
  }, jsx("input", {
    css: nativeRadioStyles,
    type: "radio",
    name: name,
    checked: checked,
    onChange: function onChange() {
      return _onChange(value);
    },
    disabled: disabled
  }), jsx(FocusHighlight, null), children);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/ButtonToggle/item.js
// module id = 1235
// module chunks = 0